import {
  FLOW_DESIGER_PALETTE_SCROLL_TO_STEP,
  FLOW_DESIGER_PALETTE_SELECT_TAB,
} from 'actions/flowDesigner/palette';
import { PaletteTab } from 'xm-constants/flowDesignerPalette';

export const getInitialState = () => ({
  selectedTabId: PaletteTab.TRIGGERS,
  scrolledToStepId: null,
});

export default function flowDesignerPreferences(
  state = getInitialState(),
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case FLOW_DESIGER_PALETTE_SELECT_TAB: {
      return {
        ...state,
        selectedTabId: payload.tabId,
      };
    }
    case FLOW_DESIGER_PALETTE_SCROLL_TO_STEP: {
      return {
        ...state,
        scrolledToStepId: payload.stepId,
      };
    }
    default:
      return state;
  }
}
